<template>
  <transition name="modal">
    <div v-show="show"
         :class="classes"
         class="modal"
    >
      <div class="modal-container"
           :class="size"
           @click.stop
      >
        <div class="modal-content">
          <slot name="header" />
          <slot />
          <slot name="footer" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
    export default {
        props: ['show', 'size', 'classes'],
        mounted: function () {
           // document.addEventListener("keydown", (e) => {
           //      if (this.show && e.keyCode == 27) {
           //          this.close();
           //      }
           //  });
        },
        methods: {
            close: function () {
                this.$emit('close');
            }
        }
    };
</script>
<style lang="scss" scoped>
.z-100 {
  z-index: 100;
}
</style>